import http from './http/request';
import httpAuth from './http/httpAuth';
// import userAuthorities from '../constants/userAuthorities';

// 登录
export const login = (params, config) => http.post('/riskcontrol/oauth/login', params, { ...config });

export const changePwd = (params, config) => http.post('/riskcontrol/platform/api/back/user/modifyPassword', params, { ...config });

// 获取用户信息
export const getUserInfo = () => httpAuth.get('/riskcontrol/global/user');

// 获取权限菜单(目前本地常量配置)
export const authMenuApi = () => {
  const list = JSON.parse(window.localStorage.getItem('menuList') || '[]').filter((item) => item.action !== 'console.statistics.address');
  const resData = { code: 0, data: { list: list.map((item) => ({ ...item, name: item.action, title: item.name })) } };
  return new Promise((reslove) => reslove(resData));
};
